import React from 'react';
import useReveal from '../../hooks/useReveal';

export default function AboutMe() {
  useReveal();

  return (
    <section id="ben-kimim" className="ckr-section" style={{ background: 'transparent' }}>
      <div className="ckr-container">
        <div className="ckr-about-grid">
          <div className="ckr-fade-up ckr-about-portrait-wrap">
            <div className="ckr-about-portrait-frame">
              <img className="ckr-about-photo" src="/media/kutay-about-20261021.png" width="941" height="1672" fetchPriority="high" decoding="async" alt="M. Kutay Öztürk" />
            </div>
          </div>

          <div className="ckr-fade-up ckr-about-copy">
            <h1 style={{ fontSize: 'clamp(28px, 3vw, 38px)', fontWeight: 600, color: 'var(--ckr-gold-soft)', marginTop: 0, marginBottom: 8 }}>
              Ben Kimim?
            </h1>

            <p>1985 yılında Çanakkale’nin Çan ilçesinde doğdum. 2008’de Marmara Üniversitesi Güzel Sanatlar Fakültesi Seramik Bölümü’nden mezun oldum. Sektörde bir süre çalıştıktan sonra, 2013’te İstanbul’a taşınıp kendi yolumu çizmeye karar verdim. İstanbul’da kafe ve dövme stüdyoları işlettim. Pandemiyle birlikte başlayan değişim sürecinde, 2022’de memleketim Çanakkale’ye temelli yerleştim.</p>
            <p>Ben, yaptığım işin anlamlı olması gerektiğine inanan biriyim. Üretemediğim, değer katamadığım ve insanlara fayda sağlayamadığım bir iş benim için sürdürülebilir değildir.</p>
            <p className="ckr-about-emphasis">Bir insanın değerinin yalnızca sahip olduklarında değil, çevresine ve insanların hayatına kattıklarında saklı olduğuna inanıyorum.</p>
            <p>Gayrimenkul danışmanlığına da bu anlayışla yaklaşıyorum. Çünkü bir mülk almak ya da satmak; bazen yılların birikimi, bazen yeni bir hayatın başlangıcıdır. Böyle kararların bilgiyle, sorumlulukla ve vicdanla yönetilmesi gerektiğini düşünüyorum.</p>
            <p>Mesleğimde özellikle güvendiğim alanlardan biri gayrimenkul değerleme çalışmalarıdır. Öngördüğüm fiyat aralıklarının gerçek alıcı teklifleriyle örtüşmesi, yaklaşımıma duyduğum güveni pekiştiriyor. Benim için doğru değerleme, piyasanın bir mülke nasıl karşılık vereceğini isabetli okuyabilmektir.</p>
            <p><strong>Çanakkale Konut Rehberi’ni de bu anlayışla kurdum:</strong> İnsanların açık ve gerçekçi cevaplar bulabildiği, kararlarını ezbere ilan fiyatları yerine gerçek piyasa verilerine dayandırabildiği bir rehber sunmak için.</p>
            <p className="ckr-about-closing">Çünkü benim için gerçek başarı, ne kadar kazandığım kadar, ne kadar fayda sağladığımdır. Umarım beraber çalışma şansı buluruz.</p>
            <p className="ckr-about-signature"><strong>M. Kutay Öztürk</strong><br />Gayrimenkul Danışmanı | Çanakkale Konut Rehberi</p>

            <a href="/" className="ckr-btn ckr-btn-ghost" style={{ marginTop: 14 }}>Ana sayfaya dön</a>
          </div>
        </div>
      </div>
    </section>
  );
}
